import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

type SubmitButtonProps = {
  isDirty?: boolean;
  isSubmitting?: boolean;
  isValid?: boolean;
  className?: string;
  variant?: string;
  disabled?: boolean;
  onClick?: (...args: any[]) => any;
};

export const SubmitButton: React.FC<React.PropsWithChildren<SubmitButtonProps>> = ({
  isDirty = false,
  isSubmitting = false,
  isValid = true,
  className,
  disabled,
  variant = 'primary',
  onClick,
  children,
}) => {
  const { t } = useTranslation();

  const handleOnClick = () => {
    if (!isValid) {
      toast.error(t('notifications.errors.invalidForm'));
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <Button type="submit" variant={variant} disabled={!!disabled || !isDirty || isSubmitting} className={className} onClick={handleOnClick}>
      {children}
    </Button>
  );
};
